import type { ComponentPropsWithoutRef, ElementType } from "react";
import { cn } from "@/lib/cn";

type IconButtonProps<T extends ElementType = "button"> = {
  as?: T;
} & Omit<ComponentPropsWithoutRef<T>, "as">;

export const IconButton = <T extends ElementType = "button">({
  as,
  className,
  ...props
}: IconButtonProps<T>) => {
  const Component = as ?? "button";
  return (
    <Component
      className={cn(
        "flex h-11 w-11 items-center justify-center rounded-full text-muted-foreground",
        className,
      )}
      {...(props as ComponentPropsWithoutRef<T>)}
    />
  );
};
